import { Box, Divider, Text } from '@wix/design-system';
import React, { useContext } from 'react';
import { EditorContext, ModalContext, RicosContext } from 'ricos-context';
import { FloatingLayout } from 'wix-rich-content-ui-components';

import { INSERT_POLL_MODAL_ID } from '../../consts';
import { PRESET_SELECTOR_MODAL } from '../../dataHooks';
import type { PollPluginEditorConfig } from '../../types';
import { POLL_TYPE } from '../../types';
import type { PresetType } from './preset-data';
import { createInitialPollData } from './preset-data';
import { PresetPicker } from './preset-picker';

type InsertModalProps = {
  config: PollPluginEditorConfig;
};

export const InsertModal: React.FC<InsertModalProps> = ({ config }) => {
  const { t, isMobile } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const modalService = useContext(ModalContext);

  const closeModal = () => modalService.closeModal(INSERT_POLL_MODAL_ID);

  const onPollAdd = (type: PresetType) => {
    const pollData = createInitialPollData(config, type);
    queueMicrotask(() => getEditorCommands().insertBlockWithBlankLines(POLL_TYPE, pollData));
    closeModal();
  };

  return (
    <FloatingLayout
      sidePanelProps={isMobile ? {} : { width: '420px' }}
      dataHook={PRESET_SELECTOR_MODAL}
      header={
        isMobile
          ? {
              title: 'Poll',
            }
          : {
              title: t('Poll_Presets_Popup_Title'),
              subtitle: t('Poll_Presets_Popup_Subtitle'),
              showDivider: true,
            }
      }
      onCloseButtonClick={isMobile ? closeModal : undefined}
      content={{
        noPadding: isMobile,
        children: (
          <>
            {isMobile && (
              <>
                <Box direction="vertical" marginLeft="SP2" marginRight="SP2" marginBottom="SP2">
                  <Text weight="bold">{t('Poll_Presets_Popup_Title')}</Text>
                  <Text weight="thin">{t('Poll_Presets_Popup_Subtitle')}</Text>
                </Box>
                <Divider />
              </>
            )}
            <PresetPicker onPollAdd={onPollAdd} />
          </>
        ),
      }}
    />
  );
};
